module.exports = __webpack_public_path__ + "img/pump-arrow.8e35d595.svg";